import { makeStyles } from '@mui/styles';

export const useProjectSummaryToggleStyles = makeStyles({
  icon: {
    color: 'white',
    fontSize: '26px'
  },
  iconButton: {
    padding: '8px',
    borderRadius: '0.42rem',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)'
    }
  }
});
